var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M.43 5.9L14.92.05c.57-.23 1.26.23 1.03.91l-3.21 14.41c-.12.69-1.04.8-1.38.35l-3.91-5.04 5.52-7.09-6.33 6.3-6.2-2.52c-.58-.23-.58-1.14 0-1.49z", "fill-rule": "nonzero" } }] }, name: "send-mail", theme: "filled" };
export {
  l as default
};
